import React from 'react';
import {useStoreState} from 'store';
import i18n from 'i18n';
export const Footer = () => {
    const appConfig = useStoreState((state) => state.appConfigs.items);
    const year = new Date().getFullYear();
    let copyrightText = `${i18n.t('nm_feelingstream.text')} © ${year}`;
    if (appConfig?.VISION_DOCKER_TAG && appConfig.VISION_DOCKER_TAG !== 'dev') {
        copyrightText = `${copyrightText} v${appConfig.VISION_DOCKER_TAG}`;
    }

    const aiDisclaimerText = i18n.t('ht_ai_label.text');
    const knowledgeBaseText = 'Knowledge Base';
    const knowledgeBaseIndex = aiDisclaimerText.indexOf(knowledgeBaseText);
    const aiDisclaimerContent =
        knowledgeBaseIndex !== -1 ? (
            <>
                {aiDisclaimerText.slice(0, knowledgeBaseIndex)}
                <a
                    href="https://support.feelingstream.com/knowledgebase/using-ai-features-in-leadstream-responsibly/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-themecolor-muted"
                >
                    {knowledgeBaseText}
                </a>
                {aiDisclaimerText.slice(knowledgeBaseIndex + knowledgeBaseText.length)}
            </>
        ) : (
            aiDisclaimerText
        );

    return (
        <footer className="footer">
            <div className="d-flex justify-content-between align-items-center w-100 text-muted footer-text">
                <div className="mb-1">
                    {aiDisclaimerContent}
                </div>
                <div className="text-right">
                    {copyrightText}
                </div>
            </div>
        </footer>
    );
};
